module.exports = __webpack_public_path__ + "static/media/pgo89ws.8e4bbb3f.pdf";